import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Podcastlisting(porps) {

    return (
        <div className="podcast_listing tekrevol_gray_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="mb-5">
                        <div className="example" data-text="Podcast Ep">
                            <h2>Latest Episodes</h2>
                        </div>
                        <p>We collaborate with entrepreneurs and industry leaders to emphasize the importance of digital
                            transformation. We regularly invite technopreneurs and change leaders to talk about how
                            technology played a crucial role in transforming their businesses and how it helps them
                            scale up with sustainability.</p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="podcast_list">
                            <h4>Learn How Digital Transformation is the Next Big Thing in the GCC</h4>
                            <div className="podcast_txt">
                                <p>Listen to the discussion on technological affairs in the GCC in our latest podcast release...</p>
                            </div>
                            <Link to="/podcast/technology-for-change-season3-ep3"
                                  className="btn_podcast"> Listen to this Episode
                            </Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="podcast_list">
                            <h4>Cyberpsychologist Dr. Michael Nuccitelli Shares Ipredators Vision</h4>
                            <div className="podcast_txt">
                                <p>In our latest Technology for a Change episode, Season 3, TekRevol’s Principal Product Strategist...</p>
                            </div>
                            <Link to="/podcast/technology-for-change-season3-ep2"
                                  className="btn_podcast"> Listen to this Episode
                            </Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="podcast_list">
                            <h4>Discussing Tech In Dubai & GCC</h4>
                            <div className="podcast_txt">
                                <p>In the latest episode of Technology for a Change, Season 3, TekRevol’s Principal Product Strategist, Hady Shaikh, interviewed Yalla!Market’s founder, Leo Dovbenko....</p>
                            </div>
                            <Link to="/podcast/technology-for-change-season3-ep1"
                                  className="btn_podcast"> Listen to this Episode
                            </Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );

}


export default Podcastlisting;